import React, { useEffect, useMemo, useState } from "react";

import DataGrid, {
  Column,
  Sorting,
  FilterRow,
  HeaderFilter,
  SearchPanel,
  Paging,
  Pager
} from "devextreme-react/data-grid";
import DateBox from "devextreme-react/date-box";
import { SelectBox } from "devextreme-react/select-box";
import VARBacktestChart from "./VARBacktestChart";
import VARBacktestTable from "./VARBacktestTable";
import useCobDate from "../../hooks/useCobDate";

interface ChartDataItem {
  book: string;
  cob_date: string | Date;
  pnl_daily: number;
  daily_var: number;
}

const VARBacktesting: React.FC = () => {
    const [cobDate, setCobDate, cobLoading] = useCobDate("/pnl_latest_cob");
    const [selectedOption, setSelectedOption] = useState<string>('Market Maker Total');
    const [rowLabels, setRowLabels] = useState<string[]>([]);
    const [cols, setCols] = useState<string[]>([]);
    const [data, setData] = useState<any[]>([]);
    const [chartData, setChartData] = useState<ChartDataItem[]>([]);

const handleVarTableChange = (value: ChartDataItem[]) => {
    //console.log("Got from child:", value);
    setChartData(value)
  };

return (
  <div
    style={{
      height: "calc(90vh - var(--header-h))",  // dashboard fills viewport
      display: "grid",
      gridTemplateRows: "auto 1fr",             // row1 = auto, row2 = flex
      gridTemplateColumns: "1fr",
      gap: 8,
      boxSizing: "border-box",
      overflow: "hidden"
    }}
  >

    {/* ROW 1: Filters */}
    <div
      style={{
        display: "flex",
         justifyContent: "flex-start",
          gap: 12,
          //marginBottom: 12,
          marginTop: 12,
          marginLeft: 75

      }}
    >
      <DateBox
        value={cobDate}
        type="date"
        displayFormat="dd/MM/yyyy"
        onValueChanged={(e: any) => setCobDate(e.value)}
        width={180}
      />

      <SelectBox
        items={[
          "Market Maker Total",
          "Simon Fothergill",
          "Hugo Cap",
          "Jelle Van Velzen/Ronald Van der Graaf",
          "Joseph Eagell",
          "Anil Dharan",
          "France",
          "Maxime Florentin",
          "Enrico Antonini",
        ]}
        value={selectedOption}
        onValueChanged={(e: any) => setSelectedOption(e.value)}
        placeholder="Market Maker Total"
        width={220}

      />
    </div>

    {/* ROW 2: Table + Chart */}
    <div
      style={{
        display: "grid",
        gridTemplateRows: "1fr 2fr",         // both grow/shrink equally
        //gap: 8,
        overflow: "hidden",
         background: "transparent",
      }}
    >
      {/* TABLE */}
      <div style={{ overflow: "auto" }}>
          <VARBacktestTable cobDate={cobDate} onChange = {handleVarTableChange} ></VARBacktestTable>
      </div>

      {/* CHART */}
      <div style={{ overflow: "auto" }}>
        <VARBacktestChart page= {selectedOption} chart_data={chartData.filter(item => item.book === selectedOption)}/>
      </div>
    </div>
  </div>
);

}

export default VARBacktesting;
